import React from "react";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Tooltip from "@material-ui/core/Tooltip";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { DatePicker } from "@material-ui/pickers";

import RefreshIcon from "@material-ui/icons/Refresh";

import { RANGE_PRESETS } from "./dashboardUtils";

const useStyles = makeStyles((theme) => ({
  row: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(2),
  },
  select: {
    minWidth: 180,
  },
  date: {
    width: 150,
  },
}));

// from/to are moment objects; the pickers work in Date (date-fns utils).
const DashboardFilters = ({
  preset,
  from,
  to,
  type,
  isLoading,
  onPresetChange,
  onCustomRangeChange,
  onTypeChange,
  onRefresh,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.row}>
      <FormControl className={classes.select} size="small">
        <InputLabel id="dashboard-range-label">Date range</InputLabel>
        <Select
          labelId="dashboard-range-label"
          value={preset}
          onChange={(e) => onPresetChange(e.target.value)}
        >
          {RANGE_PRESETS.map((p) => (
            <MenuItem key={p.key} value={p.key}>
              {p.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <DatePicker
        className={classes.date}
        label="From"
        format="MMM d, yyyy"
        value={from.toDate()}
        maxDate={to.toDate()}
        disabled={preset !== "custom"}
        onChange={(date) =>
          onCustomRangeChange({ from: moment(date).startOf("day"), to })
        }
      />
      <DatePicker
        className={classes.date}
        label="To"
        format="MMM d, yyyy"
        value={to.toDate()}
        minDate={from.toDate()}
        disabled={preset !== "custom"}
        onChange={(date) =>
          onCustomRangeChange({ from, to: moment(date).startOf("day") })
        }
      />

      <ToggleButtonGroup
        size="small"
        exclusive
        value={type}
        onChange={(e, value) => value && onTypeChange(value)}
        aria-label="Order type"
      >
        <ToggleButton value="all">All</ToggleButton>
        <ToggleButton value="package">Packages</ToggleButton>
        <ToggleButton value="condo">Condos</ToggleButton>
      </ToggleButtonGroup>

      <Tooltip title="Refresh">
        <span>
          <IconButton onClick={onRefresh} disabled={isLoading} size="small">
            <RefreshIcon />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
};

export default DashboardFilters;
